export const headerContainer = {
  as: "header",
  align: "center",
  px: "1rem",
  minH: { base: "56px", md: "64px" },
  py: { base: 2, md: 0 },
  bg: "white",
  color: "gray.900",
  boxShadow: "sm",
  borderBottom: "1px solid",
  borderColor: "gray.200",
};

export const contentContainer = {
  direction: "row",
  align: { base: "center", md: "center" },
  justify: "space-between",
  flexWrap: { base: "wrap", md: "nowrap" },
  width: "100%",
  gap: { base: 2, md: 3 },
};

export const topRowContainer = {
  alignItems: "center",
  gap: "10px",
  flexShrink: 0,
};

export const navBarStyle = {
  as: "nav",
  align: "center",
  gap: 2,
  flex: 1,
  justify: "center",
};

export const userMenuButtonStyle = {
  variant: "outline",
  color: "gray.700",
  bg: "white",
  borderColor: "gray.200",
  _hover: { bg: "gray.50", borderColor: "indigo.200" },
  _active: { bg: "indigo.50" },
  fontSize: "sm",
};

export const userMenuItemStyle = {
  color: "gray.700",
  _hover: { bg: "gray.100" },
};

export const logoutMenuItemStyle = {
  color: "red.600",
  _hover: { bg: "red.50" },
};